import { axiosInstance } from 'services';
import { AxiosResponse } from 'axios';

import { API_KEY } from 'constants/apis';

import {
    IAvgVotesAndTokenPrice,
    IOrganizationActiveDelegate,
    IOrganizationActiveVoter,
    IOrganizationHoldingToken,
    IOrganizationTab,
    IOrganizationTabResponse,
    IOrganizationTopDelegate,
    IOrganizationTopVoter,
    IOrganizationTrends,
    IOrganizationVoterGroups,
    IOrganizationVoterInterestsResponse,
    ITreasuryComposition,
    ITreasuryCompositionGraph,
    IVotingToken,
} from '../../types/interfaces';
import { treasuryCompositionMock, treasuryDiversificationMock } from 'mockedData/org_treasury.page';
import { orgHoldingTokenMock, tokenPrVsVotesGraphMock, votingTokenMock } from 'mockedData/org_token.tab';
import { delegatesMock } from 'mockedData/org_delegates.tab';
import { avVotesPerProposalMock, govProposalsMock, govSuccessfulProposals, govVotersMock, govVotesMock, yearByYearMock } from 'mockedData/org_voter_trends.tab';
import { orgTabsMock } from 'mockedData/organization.page';

export const OrganizationTabsApi = {
    getOrganizationTabs: (
        organizationId: string,
    ): Promise<AxiosResponse<any>> =>
        // axiosInstance.get<IOrganizationTabResponse<IOrganizationTab[]>>(
        //     `organization/${API_KEY}/${organizationId}/tabs`,
        // ),
        Promise.resolve({
          data: orgTabsMock,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getOrganizationActiveDelegates: (
        organizationId: string,
    ): Promise<AxiosResponse<any>> =>
        // axiosInstance.get<IOrganizationTabResponse<IOrganizationActiveDelegate[]>>(
        //     `organization/${API_KEY}/${organizationId}/active_delegates`,
        // ),
        Promise.resolve({
          data: {},
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getOrganizationTopDelegates: (
        organizationId: string,
    ): Promise<AxiosResponse<any>> =>
        // axiosInstance.get<IOrganizationTabResponse<IOrganizationTopDelegate[]>>(
        //     `organization/${API_KEY}/${organizationId}/top_delegates`,
        // ),
        Promise.resolve({
          data: delegatesMock,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getOrganizationActiveVoters: (
        organizationId: string,
    ): Promise<AxiosResponse<IOrganizationTabResponse<IOrganizationActiveVoter[]>>> =>
        axiosInstance.get<IOrganizationTabResponse<IOrganizationActiveVoter[]>>(
            `organization/${API_KEY}/${organizationId}/active_voters`,
        ),
    getOrganizationTopVoters: (
        organizationId: string,
    ): Promise<AxiosResponse<IOrganizationTabResponse<IOrganizationTopVoter[]>>> =>
        axiosInstance.get<IOrganizationTabResponse<IOrganizationTopVoter[]>>(
            `organization/${API_KEY}/${organizationId}/top_voters`,
        ),
    getOrganizationProposalsTrends: (
        organizationId: string,
    ): Promise<AxiosResponse<any>> =>
        // axiosInstance.get<IOrganizationTabResponse<IOrganizationTrends[]>>(
        //     `organization/${API_KEY}/${organizationId}/governance_trends/proposals`,
        // ),
        Promise.resolve({
          data: govProposalsMock,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getOrganizationSuccessfulProposalsTrends: (
        organizationId: string,
    ): Promise<AxiosResponse<any>> =>
        // axiosInstance.get<IOrganizationTabResponse<IOrganizationTrends[]>>(
        //     `organization/${API_KEY}/${organizationId}/governance_trends/successful_proposals`,
        // ),
        Promise.resolve({
          data: govSuccessfulProposals,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getOrganizationVotesTrends: (
        organizationId: string,
    ): Promise<AxiosResponse<any>> =>
        // axiosInstance.get<IOrganizationTabResponse<IOrganizationTrends[]>>(
        //     `organization/${API_KEY}/${organizationId}/governance_trends/votes`,
        // ),
        Promise.resolve({
          data: govVotesMock,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getOrganizationVotersTrends: (
        organizationId: string,
    ): Promise<AxiosResponse<any>> =>
        // axiosInstance.get<IOrganizationTabResponse<IOrganizationTrends[]>>(
        //     `organization/${API_KEY}/${organizationId}/governance_trends/voters`,
        // ),
        Promise.resolve({
          data: govVotersMock,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getOrganizationAverageVotesPerProposalTrends: (
        organizationId: string,
    ): Promise<AxiosResponse<any>> =>
        // axiosInstance.get<IOrganizationTabResponse<IOrganizationTrends[]>>(
        //     `organization/${API_KEY}/${organizationId}/governance_trends/average_votes_per_proposal`,
        // ),
        Promise.resolve({
          data: avVotesPerProposalMock,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getOrganizationYearByYearVotes: (
        organizationId: string,
    ): Promise<AxiosResponse<any>> =>
        // axiosInstance.get<IOrganizationTabResponse<IOrganizationTrends[]>>(
        //     `organization/${API_KEY}/${organizationId}/governance_trends/year_by_year`,
        // ),
        Promise.resolve({
          data: yearByYearMock,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getOrganizationVoterInterests: (
        organizationId: string,
        tableType: string,
    ): Promise<AxiosResponse<IOrganizationTabResponse<IOrganizationVoterInterestsResponse>>> =>
        axiosInstance.get<IOrganizationTabResponse<IOrganizationVoterInterestsResponse>>(
            `organization/${API_KEY}/${organizationId}/voter_interests?tableType=${tableType}`,
        ),
    getOrganizationTreasuryTrends: (organizationId: string): Promise<AxiosResponse<any>> =>
        //axiosInstance.get<IOrganizationTabResponse<any>>(`organization/${API_KEY}/${organizationId}/treasury_trends`),
        Promise.resolve({
          data: {},
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getOrganizationVotingToken: (
        organizationId: string,
    ): Promise<AxiosResponse<any>> =>
        // axiosInstance.get<IOrganizationTabResponse<IVotingToken>>(
        //     `organization/${API_KEY}/${organizationId}/voting_token`,
        // ),
        Promise.resolve({
          data: votingTokenMock,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getOrganizationAvgVotesAndTokenPriceGraph: (
        organizationId: string,
    ): Promise<AxiosResponse<any>> =>
        // axiosInstance.get<IAvgVotesAndTokenPrice>(
        //     `organization/${API_KEY}/${organizationId}/token_price_vs_votes_graph`,
        // ),
        Promise.resolve({
          data: tokenPrVsVotesGraphMock,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getOrganizationTreasuryComposition: (organizationId: string): Promise<AxiosResponse<any[]>> =>
        //axiosInstance.get<ITreasuryComposition[]>(`organization/${API_KEY}/${organizationId}/treasury_breakdown`),
        Promise.resolve({
          data: treasuryDiversificationMock,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getOrganizationTreasuryCompositionGraph: (
        organizationId: string,
    ): Promise<AxiosResponse<ITreasuryCompositionGraph>> =>
        // axiosInstance.get<ITreasuryCompositionGraph>(
        //     `organization/${API_KEY}/${organizationId}/treasury_composition_graph`,
        // ),
        Promise.resolve({
          data: treasuryCompositionMock,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getOrganizationHoldingToken: (organizationId: string): Promise<AxiosResponse<IOrganizationHoldingToken[]>> =>
        // axiosInstance.get<IOrganizationHoldingToken[]>(
        //     `organization/${API_KEY}/${organizationId}/organizations_holding_token`,
        // ),
        Promise.resolve({
          data: orgHoldingTokenMock,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getOrganizationVoterGroups: (
        organizationId: string,
    ): Promise<AxiosResponse<any>> =>
        // axiosInstance.get<IOrganizationTabResponse<IOrganizationVoterGroups>>(
        //     `organization/${API_KEY}/${organizationId}/voter_groups`,
        // ),
        Promise.resolve({
          data: {},
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
};
